import React from 'react'

const ActiveDevices = ({ devices = [] }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Devices</h3>
      <div className="space-y-3">
        {devices.map((device) => (
          <div
            key={device.id}
            className="flex items-center justify-between p-3 border border-gray-200 rounded-lg hover:bg-gray-50"
          >
            <div className="flex items-center space-x-3">
              <div className={`w-3 h-3 rounded-full ${device.isActive ? 'bg-green-500' : 'bg-gray-300'}`} />
              <div>
                <h4 className="font-medium text-gray-900">{device.name}</h4>
                <p className="text-sm text-gray-500">{device.type}</p>
              </div>
            </div>
            <div className="text-right">
              <div className="flex items-center space-x-2 text-sm">
                <span className={`px-2 py-1 rounded-full ${
                  device.isActive 
                    ? 'bg-green-100 text-green-800' 
                    : 'bg-gray-100 text-gray-800'
                }`}>
                  {device.isActive ? 'Active' : 'Inactive'}
                </span>
                {device.isActive && (
                  <>
                    <span className="text-gray-500">{device.battery}%</span>
                    <span className="text-gray-500">•</span>
                    <span className="text-gray-500">{device.speed} km/h</span>
                  </>
                )}
              </div>
            </div>
          </div>
        ))}
        {devices.length === 0 && (
          <p className="text-gray-500 text-center py-4">
            No active devices
          </p>
        )}
      </div>
    </div>
  )
}

export default ActiveDevices